<template>
    <div>
        <div class="centered-card">
            <v-card margin="10px" elevation="0" class="limited-width">
                <v-card-text style="font-size: 15px;">
                    <div class="text--primary" style="text-align: justify">
                        Our group offers thesis supervision for HSG students in the Bachelor Computer Science and Master
                        Computer
                        Science
                        programmes.
                        <br>
                        <br>
                        Our research interests are centered around information security and applied cryptography.
                        Some of our key interests:
                        <br>
                        <br>

                        <ul class="custom-bullet-list">
                            <li>Functional encryption</li>
                            <li>Verifiable computation</li>
                            <li>Secure, private and distributed aggregation</li>
                            <li>Secure multi-party computation</li>
                            <li>Privacy-preserving biometric authentication</li>
                            <li>Proximity-based authentication</li>
                            <li>Zero-Knowledge Proofs</li>
                        </ul>

                        The members of our group may supervise topics related to these interests. Of course we are
                        not limited to them and may also find other topics related to cyber security and
                        cryptography.
                        <br>
                        <br>
                        Feel free to contact any member of the group regarding a possible thesis. Of course you can
                        come forward with your own topic and we will try to make it work out.
                    </div>
                </v-card-text>

                <v-tabs v-model="tab" grow class="thesis-tabs">
                    <v-tab v-for="group in groups" :key="group.key">{{ group.title }}</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item v-for="group in groups" :key="group.key" :transition="false"
                        :reverse-transition="false">
                        <v-expansion-panels multiple class="completed-panels">
                            <v-expansion-panel v-for="sub in group.subsections" :key="sub.key">
                                <v-expansion-panel-header class="section-header"
                                    :style="{ backgroundColor: sub.color }">
                                    <span class="section-title">{{ sub.title }}</span>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row v-if="sub.items.length" dense class="pt-3">
                                        <v-col v-for="item in sub.items" :key="item.name" cols="12">
                                            <v-card outlined class="thesis-box" height="100%"
                                                :style="{ borderColor: sub.color }">
                                                <v-card-text>
                                                    <p class="box-line"><strong>Title:</strong> {{ item.name }}</p>
                                                    <p class="box-line"><strong>Student:</strong> {{ item.student }}</p>
                                                    <p class="box-line"><strong>Supervisors:</strong> {{ item.supervisor
                                                        }}</p>
                                                    <p class="box-line">
                                                        <strong>Description:</strong> {{ item.description || '-' }}</p>
                                                    <p v-if="group.key === 'completed'" class="box-line">
                                                        <strong>Files:</strong>
                                                        <a v-if="item.files && item.files.pdf" :href="item.files.pdf"
                                                            target="_blank" rel="noopener" class="file-link">PDF</a>
                                                        <a v-if="item.files && item.files.slides"
                                                            :href="item.files.slides" target="_blank" rel="noopener"
                                                            class="file-link">Slides</a>
                                                        <a v-if="item.files && item.files.video"
                                                            :href="item.files.video" target="_blank" rel="noopener"
                                                            class="file-link">Video</a>
                                                        <span
                                                            v-if="!item.files || (!item.files.pdf && !item.files.slides && !item.files.video)">
                                                            -</span>
                                                    </p>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <div v-else class="text--secondary pt-3">No entries yet.</div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </div>
    </div>
</template>

<style scoped>
.centered-card {
    display: flex;
    align-items: flex-start;/* Aligns children to the start of the container */
    justify-content: center;
}

.limited-width {
  max-width: 60%;
  width: 60%; /* Ensures the card takes up the available width up to the max-width */
}

.thesis-tabs {
    margin-top: 15px;
}

.completed-panels {
    margin-top: 10px;
}

.section-header {
    min-height: 48px;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
}

.thesis-box .box-line {
    margin-top: 6px;
    margin-bottom: 6px;
    font-size: 14px;
}

.file-link {
    color: #00783a;
    font-weight: 600;
    text-decoration: underline;
    margin-left: 8px;
}

</style>

<script>
export default {
    data() {
        return {
            tab: 0,
            running_thesis: [],
            running_master_projects: [],
            running_bachelor_projects: [],
            completed_thesis: [],
            completed_master_projects: [],
            completed_bachelor_projects: [],
        };
    },
    computed: {
        groups() {
            return [
                {
                    key: 'completed',
                    title: 'Completed',
                    subsections: [
                        { key: 'thesis', title: 'Theses', items: this.completed_thesis, color: '#66bb6a' },
                        { key: 'master', title: "Master's Projects", items: this.completed_master_projects, color: '#a5d6a7' },
                        { key: 'bachelor', title: "Bachelor's Projects", items: this.completed_bachelor_projects, color: '#c8e6c9' },
                    ],
                },
                {
                    key: 'running',
                    title: 'Running',
                    subsections: [
                        { key: 'thesis', title: 'Theses', items: this.running_thesis, color: '#42a5f5' },
                        { key: 'master', title: "Master's Projects", items: this.running_master_projects, color: '#90caf9' },
                        { key: 'bachelor', title: "Bachelor's Projects", items: this.running_bachelor_projects, color: '#bbdefb' },
                    ],
                },
            ];
        },
    },
    created() {
        const load = (key, loader) => {
            try {
                this[key] = loader();
            } catch (error) {
                console.error(`Error loading JSON data for ${key}: ${error}`);
            }
        };

        load('running_thesis', () => require('./json/running_thesis.json'));
        load('running_master_projects', () => require('./json/running_master_projects.json'));
        load('running_bachelor_projects', () => require('./json/running_bachelor_projects.json'));
        load('completed_thesis', () => require('./json/completed_thesis.json'));
        load('completed_master_projects', () => require('./json/completed_master_projects.json'));
        load('completed_bachelor_projects', () => require('./json/completed_bachelor_projects.json'));
    },
};
</script>
